/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from 'react'
import {
	InputComponent,
	SelectComponent,
	SelectWithOther,
	SelectValue,
	FormRowAdditionalElement,
	FormRowComponent,
	FormRowElement,
	UISizes,
	i18n,
} from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import {
	ADDRESS_TYPE,
	DATA_FIELDS_WITH_TYPE,
	DEPENDENT_FIAS_FIELDS,
	MAX_LENGHT_FIELD,
	TYPE_SELECT_FIELD,
} from 'Src/constants/Address.constants'
import translate from 'Src/locale/ru'
import { getOptionsSelect } from 'Helpers'
import { SelectItem } from 'Types/item'
import { AddressSuggest } from 'Models'
import { FormComponentProps } from 'antd/lib/form'
import { validateDependentField, Validators } from 'Modules'

const { errors } = translate

export interface AddressEditFiasFieldProps extends FormComponentProps {
	disabled?: boolean
	// field: typeof FIELDS_FIAS[number]
	field: FieldNames
	disableInput?: boolean
	initialData: AddressSuggest
	isJuridical?: boolean
	saveAddress?: (value: SelectValue<SelectItem>, field: FieldNames) => void
	placeholderSelect?: string
	placeholderInput?: string
	typeAddress?: ADDRESS_TYPE
}

const disabledInput = {
	[FieldNames.FLAT]: false,
	[FieldNames.ROOM]: false,
}

export const AddressEditFiasFieldComponent: FC<AddressEditFiasFieldProps> = ({
	form,
	field,
	initialData,
	saveAddress,
	disabled,
	isJuridical,
	placeholderSelect,
	placeholderInput,
	typeAddress,
}) => {
	const { setFields, getFieldValue, validateFields } = form
	const DATA_FIELDS = DATA_FIELDS_WITH_TYPE(typeAddress)
	const dataField = DATA_FIELDS[field]
	const fieldType = dataField?.field_type
	const fieldRules = []
	const fieldTypeRules = []
	const isOther = dataField?.options_type === TYPE_SELECT_FIELD.OTHER

	useEffect(() => {
		if (
			isJuridical &&
			!getFieldValue(FieldNames.FLAT) &&
			!getFieldValue(FieldNames.FLAT_TYPE_FULL)
		) {
			fieldRules.push({
				validator: validateDependentField(FieldNames.FLAT_TYPE_FULL, errors?.[`${field}.number`]),
			})
			fieldTypeRules.push({
				validator: validateDependentField(FieldNames.FLAT, errors?.juridical_tip),
			})
			validateFields([FieldNames.FLAT, FieldNames.FLAT_TYPE_FULL])
		}
	}, [getFieldValue(FieldNames.FLAT), getFieldValue(FieldNames.FLAT_TYPE_FULL)])

	useEffect(() => {
		disabledInput[field] = !getFieldValue(fieldType) && !getFieldValue(field)

		setFields({
			[fieldType]: {
				value: initialData?.[fieldType] || undefined,
				touched: true,
			},
			[field]: {
				value: initialData?.[field] || undefined,
				touched: true,
			},
		})

		if (DEPENDENT_FIAS_FIELDS?.includes(field)) {
			if (!getFieldValue(fieldType) && getFieldValue(field)) {
				fieldTypeRules.push({
					validator: validateDependentField(fieldType, errors?.[`${field}.type`]),
				})
				validateFields([fieldType])
			}
		}

		if (DEPENDENT_FIAS_FIELDS?.includes(fieldType)) {
			if (!getFieldValue(field) && getFieldValue(fieldType)) {
				fieldRules.push({
					validator: validateDependentField(field, errors?.[`${field}.number`]),
				})
				validateFields([field])
			}
		}
	}, [getFieldValue(fieldType), getFieldValue(field), initialData])

	if (MAX_LENGHT_FIELD?.[field])
		fieldRules.push({
			validator: Validators.checkMaxLength({ payload: { max: MAX_LENGHT_FIELD[field] } }),
		})

	if (MAX_LENGHT_FIELD?.[fieldType])
		fieldTypeRules.push({
			validator: Validators.checkMaxLength({ payload: { max: MAX_LENGHT_FIELD[fieldType] } }),
		})

	const label =
		field === FieldNames.FLAT ? 'Помещение в пределах здания' : 'Помещение в пределах квартиры'

	return (
		<FormRowComponent label={label}>
			<FormRowElement>
				{isOther ? (
					<SelectWithOther
						items={dataField.options}
						placeholder={placeholderSelect ?? i18n('common.empty')}
						fieldOptions={{
							initialValue: initialData?.[fieldType] || undefined,
							rules: fieldTypeRules,
						}}
						fieldName={fieldType}
						showSearch
						allowClear
						form={form}
						filterOption
						disabled={disabled}
						onChange={(value) => saveAddress?.(value, fieldType)}
					/>
				) : (
					<SelectComponent
						items={
							dataField?.options_type === TYPE_SELECT_FIELD.SELECT
								? getOptionsSelect(dataField?.options)
								: dataField.options
						}
						placeholder={placeholderSelect ?? i18n('common.empty')}
						fieldOptions={{
							initialValue: initialData?.[fieldType] || undefined,
							rules: fieldTypeRules,
						}}
						fieldName={fieldType}
						showSearch
						allowClear
						form={form}
						filterOption
						disabled={disabled}
						onChange={(value) => saveAddress?.(value, fieldType)}
					/>
				)}
			</FormRowElement>
			<FormRowAdditionalElement size={UISizes.SMALL}>
				<InputComponent
					placeholder={placeholderInput ?? i18n('common.empty')}
					onChange={(value) => saveAddress?.(value, field)}
					disabled={disabled || disabledInput[field]}
					fieldName={field}
					fieldOptions={{
						initialValue: initialData?.[field] || undefined,
						rules: fieldRules,
					}}
					form={form}
				/>
			</FormRowAdditionalElement>
		</FormRowComponent>
	)
}
